import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory, useLocation } from "react-router-dom";
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import usePortal from './hooks/portal';
import config from '../config';
import draftToHtml from 'draftjs-to-html';

const parseSummary = text => {
  try {
    return draftToHtml(JSON.parse(text));
  }
  catch {
    return text;
  }
}

const useStyles = makeStyles(theme => ({
  card: {
    //maxWidth: 345,
    //minWidth: 300
  },
  media: {
    height: 0,
    //paddingTop: '75%', //'56.25%', // 16:9
    cursor: 'pointer',
    position: 'relative',
  },
  title: {
    fontSize: '1.1rem',
    cursor: 'pointer',
    overflow: 'hidden',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
  },
  summary: {
    maxHeight: 115,
    overflow: 'hidden',
    display: '-webkit-box',
    '-webkit-line-clamp': 5,
    '-webkit-box-orient': 'vertical',
    cursor: 'pointer',
  },
  speakers: {
    maxHeight: 100,
    overflow: 'hidden',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    //cursor: 'pointer',
  },
  priceSpan: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    width: 0,
    height: 0,
    borderStyle: 'solid',
    borderWidth: `0 0 ${theme.spacing(16)}px ${theme.spacing(16)}px`,
    borderColor: `transparent transparent ${theme.palette.primary.main} transparent`
  },
  price: {
    position: 'absolute',
    bottom: theme.spacing(1),
    right: theme.spacing(1),
    color: theme.palette.primary.contrastText,
  },
}));

const RecordingCard = ({ recording, openModal, openDetails, user }) => {
  const classes = useStyles();
  const portal = usePortal();
  const { name, speakers, summary, ratio, previewUrl, alias, questionsCount, ceHours, ceTypeName, id } = recording;
  const speakersString = speakers.map((speaker) => speaker.firstName + speaker.lastName).join(", ");
  const link = (questionsCount > 0 && alias) ? portal.urlPrefix + `/quizzes/${recording.id}` : null;
  const cdnUrl = previewUrl.replace('https://slidespielweb.azurewebsites.net/', 'https://sspwebapi.azureedge.net/');
  const imagePadding = (100 / ratio) + '%';
  const history = useHistory();
  const { pathname } = useLocation();

  let price = isMember ? recording.priceForMembers : recording.price;

  const handleRecordOpen = () => {
    if (link)
      history.push(link);
    else if (alias) {
      openModal("isRecordOpened", { alias, ratio, id: recording.id });
      history.push(pathname + "/" + id);
    }
    else {
      if (price)
        openModal("isRecordBuyOpened", recording);
      else
        history.push(pathname + "/signup");
    }
  }

  const isMember = user?.isMember;
  if (!user && price)
    price = `${recording.priceForMembers} / $${recording.price}`
  const subheader = config.hasCme && (ceHours ? `${ceHours} Hours ${ceTypeName} Credit(s)` : "No CME");

  return (
    <Card className={classes.card}>
      <CardHeader
        title={name}
        subheader={subheader}
        classes={{
          title: classes.title
        }}
        onClick={handleRecordOpen}
      />
      <CardMedia
        className={classes.media}
        image={cdnUrl}
        title={name}
        style={{ paddingTop: imagePadding }}
        onClick={handleRecordOpen}
      >
        {(!recording.alias && !!price) &&
          <>
            <span className={classes.priceSpan} />
            <Typography variant="subtitle1" className={classes.price}>${price}</Typography>
          </>
        }
      </CardMedia>
      <CardContent>
        <Typography variant="subtitle2" gutterBottom component="p" className={classes.speakers}>
          {speakersString}
        </Typography>
        <Typography variant="body2" color="textSecondary" component="p" className={classes.summary} onClick={openDetails(id)} dangerouslySetInnerHTML={{ __html: parseSummary(summary) }} />
      </CardContent>
    </Card>
  );
}

export default RecordingCard;
